export default __webpack_public_path__ + "static/tanecni-kurzy-5-fe5f6432b7c74f7f7b86611fae010298.jpg";